var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-container[data-v-106c86ed]{width:100%;min-height:calc(100vh - 50px);max-height:100%;background:url(" + escape(require("../../assets/img/banner2.png")) + ") no-repeat;background-size:100%}.dashboard-container .welcome[data-v-106c86ed]{width:100%;text-align:center;padding-top:50px;font-size:60px;color:#5a8fdc}.dashboard-container .title[data-v-106c86ed]{width:100%;text-align:center;font-size:18px;color:#87b2e2;margin-top:20px}\n", ""]);

// exports
